import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledModalContainer = styled(Flex)`
    box-sizing: border-box;
    justify-content: center;
    overflow-y: auto;
    overflow-x: clip;
    width: 100%;
    height: 95%;
    margin: 20px 0;

    .swTable-headerCell {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

export const StyledLoaderWrapper = styled(Flex)`
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

export const StyledInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding-left: 24px;

    position: absolute;
    top: 50px;
    left: 0;
`;

export const StyledInfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledIconWrapper = styled.div`
    width: 16px;
    height: 16px;
`;

export const StyledText = styled.span`
    display: block;
    color: ${colorsPalettes.carbon["400"]};
    font-size: 0.85rem;
    line-height: 16px;
`;
